export const APIErrorCode = {
    SESSION_EXPIRED: 1376331503,
    NOT_AUTHORIZED: 1454496734,
    PAYMENT_CANNOT_BE_CANCELLED: 1610441436,
};
